import React from 'react';
import { Form } from 'antd';
import pickBy from 'lodash/pickBy';
import i18next from 'i18next';
import { translate } from 'react-i18next';
import {
  getLanguageNameByKey,
  getDefaultLanguageKey,
  getLanguageIdByKey
} from 'Parts/common/langUtils';
import { get } from 'lodash';

import SettingsColumn from '../../components/SettingsColumn';
import LanguageBoxForm from '../../components/LanguageBoxFormContainer';
import Wysiwyg, { wrapText } from 'Parts/ui/components/fields/Wysiwyg';
import CancelAndSaveButtons from '../../components/CancelAndSaveButtons';

import PagesGuidelinesForm_EN from './locales/PagesGuidelinesForm_en.json';
import PagesGuidelinesForm_FR from './locales/PagesGuidelinesForm_fr.json';

const GUIDELINES_CONTENT_TYPE = 2;

class PagesGuidelinesForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      contentLang: getDefaultLanguageKey(get(this.props, 'languages')) || this.props.locale
    };

    this.changeHasHappened = false;

    this.WysiwygRef = React.createRef();

    i18next.addResourceBundle('en', 'PagesGuidelinesForm', PagesGuidelinesForm_EN);
    i18next.addResourceBundle('fr', 'PagesGuidelinesForm', PagesGuidelinesForm_FR);
  }

  handleContentLangChange = lang => {
    this.setState(
      {
        contentLang: lang
      },
      () => (this.changeHasHappened = false)
    );
  };

  checkForChange = value => {
    if (this.props.form.isFieldTouched('guidelines')) this.changeHasHappened = true;
  };

  getGuidelines = (lang = null) => {
    const lng = lang
      ? getLanguageNameByKey(lang, false)
      : getLanguageNameByKey(this.state.contentLang, false);
    return get(this.props, `contentGuidelines[${lng}].content`, '');
  };

  handleSubmit = e => {
    e.preventDefault();
    this.changeHasHappened = false;
    const { validateFields, isFieldTouched } = this.props.form;

    validateFields({ force: true }, (err, allValues) => {
      if (!err) {
        const updatedValues = pickBy(allValues, (value, key) => isFieldTouched(key));

        if (updatedValues.guidelines === this.props.content) {
          delete updatedValues.guidelines;
        }

        const values = updatedValues.guidelines === '<p><br></p>' ? null : updatedValues.guidelines;

        // Delete platform content
        if (values === null) {
          this.props.deletePlatformContent(
            this.props.platform.id,
            GUIDELINES_CONTENT_TYPE,
            getLanguageIdByKey(this.state.contentLang)
          );
        } else if (values) {
          // update platform content
          this.props.updatePlatformContent(
            this.props.platform.id,
            values,
            this.state.contentLang,
            GUIDELINES_CONTENT_TYPE
          );
        }
      }
    });
  };

  handleCancel = () => {
    this.changeHasHappened = false;
    this.props.form.resetFields();
    this.WysiwygRef.current.getWrappedInstance('Wysiwyg').resetEditorState();
  };

  render() {
    const { props, handleSubmit, handleCancel, handleContentLangChange, getGuidelines } = this;
    const { t, form, locale, accentColors, userRoleId } = props;

    return (
      <div className="panel-content AdminFormWrap">
        <Form className="PagesGuidelinesForm" layout="horizontal" onSubmit={handleSubmit}>
          <p>{t('guidelines-description')}</p>
          <div className="inputs">
            <Wysiwyg
              ref={this.WysiwygRef}
              form={form}
              fieldId={'guidelines'}
              initialValue={getGuidelines()}
              label={t('guidelines-label')}
              counterWithTag={true}
              accentColors={accentColors}
              required={false}
              allowHeadings={false}
              allowColors={false}
              allowAlignments={false}
              allowLinks={false}
              allowLists={false}
              allowSizes={false}
              allowImages={false}
              allowVideos={false}
              allowHTML={userRoleId === 1}
              onChange={this.checkForChange}
              contentLang={this.state.contentLang}
            />
            <CancelAndSaveButtons onClickCancel={handleCancel} />
          </div>
        </Form>
        <SettingsColumn>
          <LanguageBoxForm
            handleContentLanguageChange={handleContentLangChange}
            changeHasHappened={this.changeHasHappened}
            defaultLanguage={getDefaultLanguageKey(get(this.props, 'languages')) || locale}
          />
        </SettingsColumn>
      </div>
    );
  }
}

export default translate('PagesGuidelinesForm')(PagesGuidelinesForm);
